import { FaRegCheckCircle } from "react-icons/fa";
import "../styles/actor-page.css";

const actorSessions = [
  {
    title: "Tuần 1 – Làm quen với sân khấu & Biểu cảm",
    content: [
      {
        title: "Buổi 1: Nhập môn diễn xuất",
        items: [
          "Làm quen với bạn bè & giảng viên qua trò chơi",
          "Giới thiệu về sân khấu, nghề diễn viên",
          "Trò chơi phát âm – khởi động miệng, giọng",
        ],
      },
      {
        title: "Buổi 2: Biểu cảm khuôn mặt",
        items: [
          "Các trạng thái cảm xúc cơ bản: vui, buồn, giận, sợ",
          "Diễn cảm qua gương, ảnh & trò chơi 'đoán cảm xúc'",
        ],
      },
      {
        title: "Buổi 3: Ngôn ngữ cơ thể",
        items: [
          "Sử dụng tay, chân, dáng đứng, đi, chạy theo nhân vật",
          "Thực hành: đi catwalk theo nhân vật (vua, siêu nhân, bà già…)",
        ],
      },
    ],
  },
  {
    title: "Tuần 2 – Kỹ năng nói & ứng biến",
    content: [
      {
        title: "Buổi 4: Giọng nói và phát âm",
        items: [
          "Học cách lấy hơi, phát âm tròn vành rõ chữ",
          "Thực hành đọc thơ, nói lời thoại ngắn",
        ],
      },
      {
        title: "Buổi 5: Luyện tập giọng nói qua cảm xúc",
        items: [
          "Một câu thoại – 5 cảm xúc khác nhau",
          "Thực hành ghép giọng nói & ngôn ngữ hình thể",
        ],
      },
      {
        title: "Buổi 6: Ứng biến sân khấu",
        items: [
          "Trò chơi tình huống bất ngờ",
          "Làm quen với diễn ứng tác nhóm",
        ],
      },
    ],
  },
  {
    title: "Tuần 3 – Nhập vai & Sáng tạo nhân vật",
    content: [
      {
        title: "Buổi 7: Xây dựng nhân vật",
        items: [
          "Khái niệm nhân vật – hình dung – mô tả – nhập vai",
          "Tạo nhân vật riêng: tên, tính cách, dáng đi, lời thoại",
        ],
      },
      {
        title: "Buổi 8: Diễn kịch không lời",
        items: [
          "Thực hành diễn bằng hình thể & biểu cảm",
          "Trò chơi: 'Phim câm' – đoán câu chuyện",
        ],
      },
      {
        title: "Buổi 9: Diễn tiểu phẩm ngắn",
        items: [
          "Chia nhóm – tập tiểu phẩm đơn giản (3–5 phút)",
          "Giảng viên hỗ trợ xây dựng tình huống, thoại",
        ],
      },
    ],
  },
  {
    title: "Tuần 4 – Diễn xuất nhóm & kỹ thuật sân khấu",
    content: [
      {
        title: "Buổi 10: Làm việc nhóm trong diễn xuất",
        items: [
          "Tinh thần phối hợp – lắng nghe bạn diễn",
          "Trò chơi phối hợp trên sân khấu",
        ],
      },
      {
        title: "Buổi 11: Diễn xuất với đạo cụ & trang phục",
        items: [
          "Làm quen với đạo cụ – tác động lên cảm xúc",
          "Thực hành tiểu phẩm có đạo cụ đơn giản",
        ],
      },
      {
        title: "Buổi 12: Tổng duyệt kỹ năng",
        items: [
          "Ôn luyện các kỹ năng đã học",
          "Nhận xét cá nhân & nhóm – cải thiện điểm yếu",
        ],
      },
    ],
  },
  {
    title: "Tuần 5 – Tổng hợp & Biểu diễn",
    content: [
      {
        title: "Buổi 13: Dựng tiết mục biểu diễn",
        items: ["Chia nhóm – chọn tiết mục – luyện tập có kịch bản"],
      },
      {
        title: "Buổi 14: Tổng duyệt sân khấu",
        items: ["Diễn thử – chuẩn bị âm thanh, ánh sáng, phục trang"],
      },
      {
        title: "Buổi 15: Biểu diễn & Lễ tốt nghiệp",
        items: [
          "Trình diễn trước phụ huynh & khách mời",
          "Trao giấy chứng nhận, nhận xét & chụp hình lưu niệm",
        ],
      },
    ],
  },
];

const ActorPage = () => {
  return (
    <div className="actor-page-bg">
      <div className="actor-page">
        <div className="actor-page__intro">
          <h1 className="actor-page__title">MC & Diễn viên Nhí</h1>
          <p className="actor-page__desc">
            Trẻ sẽ được làm quen với sân khấu, học cách sử dụng giọng nói, gương
            mặt và hình thể để thể hiện cảm xúc, nhập vai nhân vật, làm việc
            nhóm và biểu diễn trước phụ huynh cuối khóa. Đây là môi trường tuyệt
            vời để trẻ phát triển toàn diện về cảm xúc, giao tiếp và tư duy nghệ
            thuật.
          </p>
          <p className="actor-page__meta">
            <strong>Thời lượng:</strong> 15 buổi | <strong>Đối tượng:</strong>{" "}
            Học sinh cấp 1 & 2
          </p>
        </div>

        <div className="actor-page__extras">
          <h3 className="actor-page__extras-title">Mục tiêu khóa học</h3>
          <ul className="actor-page__extras-list">
            <li>🎭 Làm quen với sân khấu và kỹ năng diễn xuất cơ bản</li>
            <li>🗣️ Rèn luyện biểu cảm, giọng nói và ngôn ngữ cơ thể</li>
            <li>🤝 Tăng cường kỹ năng làm việc nhóm và sự tự tin</li>
            <li>🌟 Biểu diễn tiểu phẩm cuối khóa trước phụ huynh</li>
          </ul>
        </div>

        <h2 className="actor-page__section-title">Lộ trình khóa học</h2>
        <div className="actor-page__weeks">
          {actorSessions.map((week, idx) => (
            <div
              className="actor-page__week"
              key={idx}
            >
              <h3 className="actor-page__week-title">{week.title}</h3>
              {week.content.map((session, i) => (
                <div
                  className="actor-page__session"
                  key={i}
                >
                  <h4 className="actor-page__session-title">{session.title}</h4>
                  <ul className="actor-page__session-list">
                    {session.items.map((item, j) => (
                      <li
                        className="actor-page__session-item"
                        key={j}
                      >
                        <FaRegCheckCircle className="actor-page__icon" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActorPage;
